import { defineMessages } from 'react-intl';

/** The copy of the public asset share page (`/app/a/<token>`, design asset-share c Theater). */
export const assetShareMessages = defineMessages({
  mediaLabel: { id: 'app.sml.assetShare.mediaLabel', defaultMessage: '{asset} of {song} by {artist}' },
  listenTo: { id: 'app.sml.assetShare.listenTo', defaultMessage: 'Listen to {song}' },
  chooseApp: { id: 'app.sml.assetShare.chooseApp', defaultMessage: 'Choose your music app' },
  copyLink: { id: 'app.sml.assetShare.copyLink', defaultMessage: 'Copy link' },
  share: { id: 'app.sml.assetShare.share', defaultMessage: 'Share' },
  linkCopied: { id: 'app.sml.assetShare.linkCopied', defaultMessage: 'Link copied' },
  preview: { id: 'app.sml.assetShare.preview', defaultMessage: 'Preview' },
  zoom: { id: 'app.sml.assetShare.zoom', defaultMessage: 'Show the picture full size' },
  closeZoom: { id: 'app.sml.assetShare.closeZoom', defaultMessage: 'Close the full-size picture' },
  soundOn: { id: 'app.sml.assetShare.soundOn', defaultMessage: 'Turn on the sound' },
  soundOff: { id: 'app.sml.assetShare.soundOff', defaultMessage: 'Turn off the sound' },
  play: { id: 'app.sml.assetShare.play', defaultMessage: 'Play' },
  pause: { id: 'app.sml.assetShare.pause', defaultMessage: 'Pause' },
  madeWith: { id: 'app.sml.assetShare.madeWith', defaultMessage: 'Made with MUSIC24' },
  hookText: {
    id: 'app.sml.assetShare.hookText',
    defaultMessage: 'Artists turn one song into a month of posts.',
  },
  makeYours: { id: 'app.sml.assetShare.makeYours', defaultMessage: 'Make yours free' },
  videoFallback: {
    id: 'app.sml.assetShare.videoFallback',
    defaultMessage: 'Your browser cannot play this video.',
  },
  notFoundTitle: { id: 'app.sml.assetShare.notFound.title', defaultMessage: 'This link does not work' },
  notFoundText: {
    id: 'app.sml.assetShare.notFound.text',
    defaultMessage: 'The artist turned off this link, or the address is not complete.',
  },
  goneTitle: { id: 'app.sml.assetShare.gone.title', defaultMessage: 'This file is no longer available' },
  goneText: {
    id: 'app.sml.assetShare.gone.text',
    defaultMessage: 'The artist made newer versions, and the file of this link was removed.',
  },
  openInRelease: { id: 'app.sml.assetShare.openInRelease', defaultMessage: 'Open in release' },
  openingInRelease: { id: 'app.sml.assetShare.openingInRelease', defaultMessage: 'Opening the release…' },
  openInReleaseFailed: {
    id: 'app.sml.assetShare.openInReleaseFailed',
    defaultMessage: 'We could not open the release. Try again.',
  },
  startTrial: { id: 'app.sml.assetShare.startTrial', defaultMessage: 'Start a 7-day trial' },
  openHome: { id: 'app.sml.assetShare.openHome', defaultMessage: 'Open Home' },
  // The web page has no Download action and no "Shared by" line since the Theater design
  // (owner decision 2026-10-19). The native apps still render these two strings
  // (scripts/music24-native/i18n-keys.txt), so the catalogue keeps them.
  download: { id: 'app.sml.assetShare.download', defaultMessage: 'Download' },
  sharedBy: { id: 'app.sml.assetShare.sharedBy', defaultMessage: 'Shared by {artist} with MUSIC24' },
  bannerText: {
    id: 'app.sml.assetShare.banner.text',
    defaultMessage: 'Make a release kit like this for your own songs. Start a 7-day trial',
  },
});
